/**
 * ATTENTION: This file is auto generated by using "prepareTemplates".
 * Do not change the content!
 *
 */

/**
 * Library Index switch to autogenerate all the components and extensions
 * Used by "prepareSwitchs"
 */

import Switch from './switch/Switch'
export * from './switch/Switch'
export default Switch
